export default "__VITE_ASSET__CNVMdAAx__"